import CertificateDetails from './CertificateDetails';
import ErrorDetails from './ErrorDetails';
import SecurityDetails from './SecurityDetails';
import { observer } from 'mobx-react';
import * as React from 'react';

export interface SignatureDetailsProps {
    isSenderVerified: boolean;
    certIssuedTo?: string;
    certIssuedBy?: string;
    certValidFrom?: string;
    certValidTo?: string;
    serverVerificationResult?: number;
}

const SignatureDetails = (props: SignatureDetailsProps) => {
    return (
        <>
            <SecurityDetails isSenderVerified={props.isSenderVerified} />
            <ErrorDetails serverVerificationResult={props.serverVerificationResult} />
            <CertificateDetails
                certIssuedTo={props.certIssuedTo}
                certIssuedBy={props.certIssuedBy}
                certValidFrom={props.certValidFrom}
                certValidTo={props.certValidTo}
            />
        </>
    );
};

export default observer(SignatureDetails);
